import { IBillingMethods, ICheckoutState } from '../../../../interfaces';
import actions from './actions';

interface RecurlyError {
  code: string;
  message: string;
  name: string;
}

const checkoutReducer = (state: ICheckoutState, action: unknown): ICheckoutState => {
  const actionObj = action as { type: string; payload: unknown };
  const { type, payload } = actionObj;

  switch (type) {
    case actions.UPDATE_FIELD: {
      const { name, value } = payload as { name: string; value: string };

      if (name === 'smsOptIn') {
        return {
          ...state,
          [name]: value === 'true',
        };
      }

      return {
        ...state,
        [name]: value,
      };
    }
    case actions.SET_COUNTRY: {
      const { value } = payload as { value: string };
      return {
        ...state,
        shipCountry: value,
        shipState: '',
      };
    }
    case actions.SET_BILLING_METHOD: {
      const billingMethod = payload as IBillingMethods;
      return {
        ...state,
        billingMethod,
      };
    }
    case actions.SET_TOTAL: {
      const total = payload as number;
      return {
        ...state,
        total,
      };
    }
    case actions.SET_LOADING: {
      const loading = payload as boolean;
      return {
        ...state,
        loading,
      };
    }
    case actions.SET_ACCEPTED_TERMS: {
      const acceptedTerms = payload as boolean;
      return {
        ...state,
        acceptedTerms,
      };
    }
    case actions.ON_CAPTCHA_EXPIRED: {
      return {
        ...state,
        hCaptchaError: 'hCaptcha Token Expired',
        loading: false,
      };
    }
    case actions.ON_CAPTCHA_ERROR: {
      const hCaptchaError = payload as string;
      return {
        ...state,
        hCaptchaError,
        loading: false,
      };
    }
    case actions.ON_RECURLY_TOKEN_ERROR: {
      const recurlyError = payload as RecurlyError;
      return {
        ...state,
        recurlyError,
        loading: false,
      };
    }

    case actions.ON_FORM_ERROR: {
      const formError = payload as { msg: string; errorCode?: string };
      return {
        ...state,
        formError,
        loading: false,
      };
    }
    default:
      return state;
  }
};

export default checkoutReducer;
